import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";

/**
 * Small pill "Message" button that starts (or opens) a DM thread with a given neighbor.
 * Usage: <MessageButton peerId={author.user_id} peerName={author.name} />
 */
export default function MessageButton({ peerId, peerName, className = "", size = "sm" }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!peerId) return null;
  const isSelf = user?.user_id === peerId;

  const onClick = (e) => {
    e?.stopPropagation?.();
    if (!user) {
      toast("Log in to message neighbors");
      navigate("/login");
      return;
    }
    if (isSelf) return;
    navigate(`/messages?start=${encodeURIComponent(peerId)}`);
  };

  if (isSelf) return null;

  const dims = size === "sm"
    ? "h-7 px-2.5 text-[11px]"
    : "h-9 px-3.5 text-xs";

  return (
    <button
      data-testid={`msg-btn-${peerId}`}
      onClick={onClick}
      className={`jirani-pill inline-flex items-center gap-1 rounded-full border border-black/10 bg-white font-medium text-[#2E473B] hover:bg-[#F9F7F4] ${dims} ${className}`}
      title={`Message ${peerName || "neighbor"}`}
    >
      <MessageCircle className="h-3 w-3" /> Message
    </button>
  );
}
